import { styledOmitCustomProps } from '@braskai/ui-kit';

import { Box, css, Drawer, drawerClasses, styled } from '@mui/material';

const SMALL_DRAWER_WIDTH = 60;
const LARGE_DRAWER_WIDTH = 208;

type SContainerProps = {
  $hover?: boolean;
  $locked?: boolean;
};

export const SContainer = styled(
  Box,
  styledOmitCustomProps,
)<SContainerProps>(
  ({ theme, $locked }) => css`
    display: flex;
    flex-shrink: 0;
    width: ${$locked ? LARGE_DRAWER_WIDTH : SMALL_DRAWER_WIDTH}px;
    height: 100vh;
    z-index: ${theme.zIndex.dialog};
    transition: 0.2s width;
  `,
);

export const SDrawer = styled(
  Drawer,
  styledOmitCustomProps,
)<SContainerProps>(
  ({ theme, $locked, $hover }) => css`
    width: ${SMALL_DRAWER_WIDTH}px;
    position: fixed;
    top: 0;
    bottom: 0;
    right: unset;
    z-index: ${theme.zIndex.sidebar};
    transition: width ${theme.transitions.duration.leavingScreen}ms ${theme.transitions.easing.sharp};

    .${drawerClasses.paper} {
      padding: 0;
      box-sizing: border-box;
      border-right: 1px solid ${theme.palette.grey[200]};
      box-shadow: unset;
      overflow-x: hidden;

      ${theme.breakpoints.up('tablet')} {
        position: relative;
        z-index: ${theme.zIndex.basic};
      }
    }

    ${($locked || $hover) &&
    css`
      width: ${LARGE_DRAWER_WIDTH}px;
    `}
  `,
);
